import { app } from '../../app';

app.component('spStoreLinks', {
    templateUrl: require('./sp-store-links.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-store-links/sp-store-links.component.js